<template>
    <div class="p-md-3 w-100">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb p-0">
          <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
          <li class="breadcrumb-item active" aria-current="page"> Orders</li>
        </ol>
      </nav>
      <div class="card">
        <div class="d-flex card-header justify-content-end align-items-center">
          <div class="input-group" style="max-width: 600px;">
            <input type="text" class="form-control me-2" placeholder="Search Order. . ." v-model="searchOrderNumber">
            <button type="button" class="btn btn-success d-flex align-items-center" style="height: 44px;" @click="getOrdersByEmailAddress(1)">
              <i class="fa-duotone fa-solid fa-rotate-right me-0 me-md-2"></i>
              <span class="d-md-block d-none">Refresh Orders</span></button>
            <!-- <button type="button" style="height: 40px;" class="btn btn-success" @click="testSwal"><i class="fa-duotone fa-solid fa-rotate-right me-2"></i> TEST</button> -->
          </div>
        </div>
        <div class="card-body mt-0 pt-0">
          <table class="table">
            <thead>
              <tr>
                <th scope="col"><span class="d-md-block d-none">Order Number</span> <span class="d-md-none d-block">Order #</span></th>
                <th scope="col" class="d-none d-md-table-cell">Date</th>
                <th scope="col">Status</th>
                <th scope="col">Total</th>
                <th scope="col" style="width: 25%;" class="d-none d-md-table-cell">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in ordersList" :key="order.order_id" :order-id="order.order_id">
                <th scope="row">
                  <a class="text-secondary cursor-pointer" @click="redirectToPage('/dashboard/my-orders/'+order.order_id)">{{ order.order_number }}</a>
                </th>
                <td class="d-none d-md-table-cell">{{ moment(order.date_created).format('LL') }}</td>
                <td @click="redirectToPage('/dashboard/my-orders/'+order.order_id)" class="cursor-pointer">
                  <span class="badge text-bg-success" v-if="order.order_status == constants.ORDER_STATUS.COMPLETED">{{ order.order_status }}</span>
                  <span class="badge text-bg-success" v-else-if="order.order_status == constants.ORDER_STATUS.DELIVERED">
                    {{ order.order_status }}
                  </span>
                  <span class="badge text-bg-success" v-else-if="order.order_status == constants.ORDER_STATUS.PROCESSING">{{ order.order_status }}</span>
                  <span class="badge text-bg-danger" v-else-if="order.order_status == constants.ORDER_STATUS.FAILED">{{ order.order_status }}</span>
                  <span class="badge text-bg-warning" v-else-if="order.order_status == constants.ORDER_STATUS.VIN_REQUIRED">{{ order.order_status }}</span>
                  <span class="badge text-bg-secondary" v-else-if="order.order_status == constants.ORDER_STATUS.CANCELLED">{{ order.order_status }}</span>
                  <span class="badge text-bg-warning" v-else-if="order.order_status == constants.ORDER_STATUS.ON_HOLD">{{ order.order_status }}</span>
                  <span class="badge" style="background-color: #727CF5;" v-else>{{ order.order_status }}</span>
                </td>
                <td @click="redirectToPage('/dashboard/my-orders/'+order.order_id)" class="cursor-pointer">${{ order.total }}</td>
                <td class="d-none d-md-table-cell">
                  <button type="button" style="height: 35px;" class="btn btn-secondary me-2" @click="redirectToPage('/dashboard/my-orders/'+order.order_id)"><i class="fa-duotone fa-solid fa-eye me-1"></i> View</button>
                  <button type="button" style="height: 35px;" @click="openVINModal(order.order_id, order.order_number, order.sku[0])" class="btn btn-primary text-dark" v-if="order.order_status == constants.ORDER_STATUS.VIN_REQUIRED && order.sku.length == 1"><i class="fa-sharp-duotone fa-solid fa-barcode me-1"></i> Provide VIN</button>
                </td>
              </tr>
              <tr v-if="ordersList.length == 0">
                <td colspan="5">
                  <div class="d-flex justify-content-center align-items-center" v-if="isOrdersLoading">
                    <div class="spinner-border text-primary" role="status" >
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div v-else-if="!isLoading && ordersList.length == 0">
                    No Orders Found
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <nav aria-label="Page navigation example" v-if="totalPages > 1">
            <ul class="pagination">
              <li class="page-item" :class="{ disabled: currentPage == 1 }">
                <button class="page-link" @click="getOrdersByEmailAddress(currentPage - 1)" aria-label="Previous" :disabled="currentPage === 1">
                  <span>Previous</span>
                </button>
              </li>
              <li
                v-for="page in totalPages"
                :key="page"
                class="page-item"
              >
                <button :class="'page-link '+((parseInt(page) == parseInt(currentPage)) ? 'active':'')" @click="getOrdersByEmailAddress(page)">{{ page }}</button>
              </li>
              <!-- Next Page Button -->
              <li class="page-item" :class="{ disabled: currentPage == totalPages }">
                <button class="page-link" @click="getOrdersByEmailAddress(currentPage + 1)" aria-label="Next" :disabled="currentPage === totalPages">
                  <span>Next</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <ProvideVinModalComponent
      :isOpen="isModalOpen"
      :modalTitle="'Enter Your VIN Here'"
      :vinLength="17"
      :orderNumber="currentOrderNumber"
      :orderId="currentOrderId"
      :orderSKU="currentSku"
      :vinProvided="isVinProvided"
      :vinPlaceholder="'Please enter your 17-digit VIN'"
      @update:isOpen="updateModalOpen"
      @update:vinProvided="setStatusProcessing"
    />
    
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
//import UnderConstruction from '../components/UnderConstruction';
import ProvideVinModalComponent from '../components/ProvideVinModalComponent';
import Mixin from '../mixins/global.mixin'
import moment from 'moment'
import { mapState } from 'vuex'
import axios from 'axios'
import appConstants from '@/constants/app.constants'
import store from '@/store'
  
export default defineComponent({
  name: 'OrdersList',
  mixins: [Mixin],
  computed: mapState([
    'currentSessionEmail',
    'fedexAccessToken',
    'orderListStorage',
    'origin',
    'loginType'
  ]),
  watch: {
    searchOrderNumber: function (newVal) {
      if (newVal) {
        let orderList = this.ordersListTemp.filter((orders) => orders.order_number.includes(newVal));
        this.ordersList = orderList;
        if (orderList.length == 0) {
          if (newVal.length == 5) {
            this.getOrdersByEmailAddress(1,newVal);
          }
        }
      } else {
        this.ordersList = this.ordersListTemp;
      }
    },
    currentPage: function (newVal) {
      if (newVal < 0) {
        newVal == 1;
      }
    }
  },
  setup() {
    return {
      moment: moment,
      storeId: appConstants.CURRENT_STOREID,
      per_page: 10,
      constants: appConstants,
    }
  },
  data() {
    return {
      ordersList: [],
      ordersListTemp: [],
      isOrdersLoading: false,
      totalPages: 0,
      currentPage: 0,
      providedVIN: '',
      //provideVINModal: null,
      currentOrderId: null,
      currentOrderNumber: null,
      currentSku: null,
      searchOrderNumber: null,
      isModalOpen: false,
      isVinProvided: [],
    }
  },
  components: {
    ProvideVinModalComponent
  },
  methods: {
    getOrdersByEmailAddress: function (page, orderNumber) {
      this.isOrdersLoading = true;
      this.currentPage = 0;
      this.totalPages = 0;
      this.ordersList = [];
      this.ordersListTemp = [];
      let url = null;
      if (orderNumber) {
        url = appConstants.SITEURL+'/wp-json/custom-api/v1/orders/billing_email/?email='+this.currentSessionEmail+'&page='+page+'&per_page='+100;
      } else {
        url = appConstants.SITEURL+'/wp-json/custom-api/v1/orders/billing_email/?email='+this.currentSessionEmail+'&page='+page+'&per_page='+this.per_page;
      }
      axios.get(url)
      .then((response) => {
        store.commit('SET_ORDER_LIST_STORAGE', response);
        this.processOrderData(response, orderNumber);
      })
    },
    processOrderData: function (response, orderNumber) {
      let orders = [];
      if (orderNumber) {
        orders = response.data.orders.filter((order) => order.order_number.includes(orderNumber));
      } else {
        orders = response.data.orders;
      }
      orders.forEach((order) => {
        order.sku = [];
        switch (order.status) {
          case appConstants.ORDER_STATUS.PROCESSING.toLocaleLowerCase():
            if (order.meta_data.vin) {
              if (order.meta_data.vin == appConstants.PROVIDE_VIN_LATER) {
                order.order_status = appConstants.ORDER_STATUS.VIN_REQUIRED;
              } else {
                order.order_status = appConstants.ORDER_STATUS.PROCESSING;
              }
            } else {
              order.order_status = appConstants.ORDER_STATUS.VIN_REQUIRED;
            }
            /*Object.values(order.items).forEach((item) => {
              order.sku.push(item.sku);
              if (item.meta && item.meta._tmcartepo_data) {
                item.meta._tmcartepo_data.forEach((epo, idx, array) => {
                  var isRVCPurchased = false;
                  var isVINGiven = false;

                  switch(epo.cssclass) {
                    case appConstants.VEHICLE_CONFIG_META:
                      if (epo.value == 'Purchase') {
                        isRVCPurchased = true;
                      }
                      break;
                    case appConstants.VIN_META:
                      if (epo.value != appConstants.PROVIDE_VIN_LATER) {
                        isVINGiven = true;
                      }
                      break;
                  }
                  if (idx+1 == array.length) {
                    if (isRVCPurchased && !isVINGiven) {
                      item.isVINRequired = true;
                      order.order_status = appConstants.ORDER_STATUS.VIN_REQUIRED;
                      this.checkIfVinIsProvided(order.order_id);
                    } else {
                      item.isVINRequired = false;
                      order.order_status = appConstants.ORDER_STATUS.PROCESSING;
                    }
                  }
                });
              } else {
                order.order_status = appConstants.ORDER_STATUS.PROCESSING;
              }
            });*/
            break;
          case appConstants.ORDER_STATUS.COMPLETED.toLocaleLowerCase():
            order.order_status = appConstants.ORDER_STATUS.COMPLETED;
            var isForPickUp = Object.values(order.shipping_lines).filter( (sl) => sl.method_id == 'local_pickup').length ? true : false;
            if (moment().diff(order.date_completed, 'days') > 30) {
              order.order_status = appConstants.ORDER_STATUS.DELIVERED;
            } else {
              (isForPickUp) ? this.getShipStationOrderDetails(order.order_number) : this.getShipstationShipmentDetails(order.order_number);
            }
            break;
          case appConstants.ORDER_STATUS.FAILED.toLocaleLowerCase():
            order.order_status = appConstants.ORDER_STATUS.FAILED;
            break;
          case appConstants.ORDER_STATUS.CANCELLED.toLocaleLowerCase():
            order.order_status = appConstants.ORDER_STATUS.CANCELLED;
            break;
          case appConstants.ORDER_STATUS.ON_HOLD.toLocaleLowerCase():
            order.order_status = appConstants.ORDER_STATUS.ON_HOLD;
            break;
        }
        this.ordersList.push(order);
        this.ordersListTemp.push(order);
      });
      
      this.totalPages = response.data.pagination.total_pages;
      this.currentPage = response.data.pagination.current_page;
      this.isOrdersLoading = false;
    },
    checkIfVinIsProvided: function (order_id) {
      axios.get(appConstants.SERVICESURL+'/api/v1/vin_trackers?order_number='+order_id+'&site='+appConstants.SITEURL.replace('https://',''))
      .then( (response) => {
        if (response.data.total_count) {
          var order = this.ordersList.filter((order) => order.order_id == order_id);
          order[0].order_status = appConstants.ORDER_STATUS.PROCESSING;
        }
      })
    },
    openVINModal: async function (order_id, order_number, order_sku) {
      this.currentOrderId = order_id;
      this.currentOrderNumber = order_number;
      this.currentSku = order_sku;
      this.updateModalOpen(true);
    },
    updateModalOpen: function (value) {
      this.isModalOpen = value;
    },
    setStatusProcessing: function (value) {
      this.isVinProvided = value;
      var order = this.ordersList.filter((order) => order.order_id == value.vin_tracker.order_number);
      order[0].order_status = appConstants.ORDER_STATUS.PROCESSING;
    },
    getShipStationOrderDetails: function (orderNumber) {
      axios.get(appConstants.SHIPSTATION_BASE_URL+'orders/?orderNumber='+orderNumber, {
          headers: {
            Authorization: appConstants.SHIPSTATION_AUTH,
          },
        })
			.then(function (response) {
        if (response.data.total) {
          var order = this.ordersList.filter((order) => order.order_number == orderNumber);
          switch (true) {
            case (response.data.orders[0].orderStatus == 'awaiting_shipment' && response.data.orders[0].externallyFulfilled == false):
              order[0].order_status = appConstants.ORDER_STATUS.READY_FOR_PICK_UP;
              break;
            case (response.data.orders[0].orderStatus == 'shipped' && response.data.orders[0].externallyFulfilled == true):
              order[0].order_status = appConstants.ORDER_STATUS.PICKED_UP;
              break;
          }
        }
      }.bind(this));
    },
    getShipstationShipmentDetails: function (orderNumber) {
      axios.get(appConstants.SHIPSTATION_BASE_URL+'/shipments?orderNumber='+orderNumber, {
          headers: {
            Authorization: appConstants.SHIPSTATION_AUTH,
          },
        })
      .then((response) => {
        var stamps_com = response.data.shipments.filter((stamp) => stamp.carrierCode == 'stamps_com');
        var fedex = response.data.shipments.filter((fdx) => fdx.carrierCode == 'fedex');
        var dhl = response.data.shipments.filter((dhl) => dhl.carrierCode == 'dhl_express');
        switch (true) {
          case (fedex.length > 0):
            this.getFedexTrackingInfo(fedex[0].trackingNumber, orderNumber);
            break;
          case (dhl.length > 0):
            this.getDHLTrackingInfo(dhl[0].trackingNumber, orderNumber);
            break;
          case (stamps_com.length > 0):
            this.getStampsTrackingInfo(stamps_com[0].trackingNumber, orderNumber);
            break;
        }
      });
    },
    getStampsTrackingInfo: function (trackingNumber, orderNumber) {
      axios.get(appConstants.STAMPS_COM_BASE_URL+trackingNumber)
      .then( function (response) {
        var order = this.ordersList.filter((order) => order.order_number == orderNumber);
        if (order.length) {
          order[0].order_status = response.data.status_description;
        }
      }.bind(this))
    },
    getDHLTrackingInfo: function (trackingNumber, orderNumber) {
      var order = this.ordersList.filter((order) => order.order_number == orderNumber);
      order[0].order_status = appConstants.ORDER_STATUS.SHIPPED;
    },
    getFedexTrackingInfo: function (trackingNumber, orderNumber) {
      var bodyFormData = new FormData();
      bodyFormData.append('bodyData','{ "includeDetailedScans": true, "trackingInfo": [ {"trackingNumberInfo": { "trackingNumber": "'+trackingNumber+'"} } ] }');
      bodyFormData.append('token', this.fedexAccessToken);
      axios({
        method: "POST",
        url: appConstants.FEDEX_BASE_URL+'?op=get_tracking_details',
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        var order = this.ordersList.filter((order) => order.order_number == orderNumber);
        if (order.length) {
          order[0].order_status = response.data.output.completeTrackResults[0].trackResults[0].latestStatusDetail.description;
        }
      });
    },
  },
  mounted() {
    setTimeout( () => {
      this.toggleFullScreenSpinner(false);
    }, 500);
    if (!Object.hasOwn(this.orderListStorage, 'data')) {
      this.getOrdersByEmailAddress(1);
    } else {
      this.processOrderData(this.orderListStorage);
    }
    //this.provideVINModal = new Modal(document.getElementById('provide-vin-modal'));
  }
});
</script>
    